module.exports = __webpack_public_path__ + "media/landing_page/landing_page_bg-min-3-5972c8b0.webp";